import { yup } from '@guiker/yup-util'

export const pictureSchema = yup.object({
  url: yup.string().required(),
  s3Key: yup.string().nullable(),
})
